const icon = require('vue-svgicon');
icon.register({
    'close-thin': {
        width: 56,
        height: 56,
        viewBox: '0 0 56 56',
        data: `<path pid="0" d="M12.098 12.443L27.654 28 43.21 43.556" _stroke="#000"/><path pid="1" d="M43.21 12.443L27.656 28 12.098 43.556" _stroke="#000"/>`,
    },
});
